import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";


// API calls
export const uploadSingle = createAsyncThunk("uploadSingle", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().post(`${API_END_POINTS.uploadSingle}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.uploadSingle} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const uploadMultiple = createAsyncThunk("uploadMultiple", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().post(`${API_END_POINTS.uploadMultiple}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.uploadMultiple} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchUserData = createAsyncThunk("fetchUserData", async (data) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.sample}`);
  if (response?.status === 200) {
    data?.callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchStaffData = createAsyncThunk("fetchStaffData", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.staffList}?search=${data.search}&page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&role=${data.role}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.staffList} ====> ${JSON.stringify(
        response?.data
      )}`
    );
  }
  return response?.data;
});
export const staffStatusChange = createAsyncThunk("staffStatusChange", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.staffStatusChange}${data.status}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.staffStatusChange} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});
export const addStaff = createAsyncThunk("addStaff", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().post(`${API_END_POINTS.addStaff}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.staffStatusChange} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchIndividualStaff = createAsyncThunk("fetchIndividualStaff", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualStaff}${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.staffStatusChange} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const editStaff = createAsyncThunk("editStaff", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.editStaff}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.staffStatusChange} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const deleteStaff = createAsyncThunk("deleteStaff", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().delete(`${API_END_POINTS.deleteStaff}${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.staffStatusChange} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

 export const mainSlice = createSlice({
  name: "main",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    //Upload
    builder
      .addCase(uploadSingle.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(uploadSingle.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(uploadSingle.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    
    //Upload Multiple
    builder
     .addCase(uploadMultiple.pending, (state) => {
        state.isLoading = "loading";
     })
     .addCase(uploadMultiple.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(uploadMultiple.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    builder
      .addCase(fetchUserData.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Fetch Staff  
    builder
      .addCase(fetchStaffData.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchStaffData.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchStaffData.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Staff Status Change  
    builder
      .addCase(staffStatusChange.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(staffStatusChange.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(staffStatusChange.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Add Staff
    builder
      .addCase(addStaff.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addStaff.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addStaff.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get Individual Staff
    builder
      .addCase(fetchIndividualStaff.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualStaff.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualStaff.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Edit Staff
    builder
      .addCase(editStaff.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editStaff.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editStaff.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //delete staff  
    builder
      .addCase(deleteStaff.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteStaff.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteStaff.rejected, (state, action) => {
        state.isLoading = "failed";
      });
  },
});

export default mainSlice.reducer;
